export const getResizedImageUrl = (src, resizeWidth) => {
  let url = src;

  if (url && resizeWidth) {
    url = src.replace(/&w=[^&]+&/, '');
    url += `&w=${resizeWidth}`;
  }

  return url;
};
